import classes from "../../scss/ServiceHeroTitle.module.scss";

export default function HeroTitle({ title, className = "" }) {
  return <h1 className={`${classes.title || ""} ${className}`}>{title}</h1>;
}
